import { Outlet } from 'react-router-dom';
import AuthProgressBar from '../components/AuthProgressBar/AuthProgressBar';

const SignupLayout = () => {
  return (
    <div>
      <AuthProgressBar />
      <Outlet />             
    </div>
  );
};

export default SignupLayout;